import React, { createContext, useContext, useState } from 'react';

const ShellMenuHostContext = createContext<HTMLElement | null>(null);

/**
 * Every shell menu portals in here. The element is rendered INSIDE the shell's <Theme>
 * wrapper, so a menu that lands in it inherits the shell palette; portalled into
 * document.body it would inherit the document default instead.
 */
export const ShellMenuHostProvider = ({ children }: { children: React.ReactNode }) => {
  const [host, setHost] = useState<HTMLElement | null>(null);
  return (
    <ShellMenuHostContext.Provider value={host}>
      {children}
      <div ref={setHost} className="shell-menu-host" />
    </ShellMenuHostContext.Provider>
  );
};

/**
 * Falls back to document.body so a switcher rendered outside the shell — a unit test, or
 * any future reuse — still opens instead of throwing on a null portal target.
 */
export function useShellMenuHost(): HTMLElement {
  return useContext(ShellMenuHostContext) ?? document.body;
}
